import { Xmark } from '@peacecover/icon';
import ProfileAvatar from '../../my-page/components/ProfileAvatar';
import type { components } from '../../../types/schema';

type ApiV1CastRelationship = components['schemas']['ApiV1CastRelationship'];

interface PreviewCastRelationshipProps {
  castRelationship: ApiV1CastRelationship | null;
  iconClassName?: string;
}

const PreviewCastRelationship = ({
  castRelationship,
  iconClassName = ''
}: PreviewCastRelationshipProps) => {
  return (
    <div className="flex items-center gap-[7px]">
      <div className="flex items-center gap-[4px]">
        <ProfileAvatar
          thumbnailUrl={castRelationship?.personAThumbnailUrl}
          widthAndHeight="27px"
          svgWidthAndHeight="27px"
        />
        <p className="text-[12px] font-medium leading-[14px]">
          {castRelationship?.personAName ?? ''}
        </p>
      </div>
      <Xmark size={12} className={`text-main-dark-3 ${iconClassName}`} />
      <div className="flex items-center gap-[4px]">
        <ProfileAvatar
          thumbnailUrl={castRelationship?.personBThumbnailUrl}
          widthAndHeight="27px"
          svgWidthAndHeight="27px"
        />
        <p className="text-[12px] font-medium leading-[14px]">
          {castRelationship?.personBName ?? ''}
        </p>
      </div>
    </div>
  );
};

export default PreviewCastRelationship;
